<template>
  <input :class="['field__control', { 'field__control--end': align === 'end' }]"
    :type="native"
    :value="modelValue ?? ''"
    :title="long ? String(modelValue) : undefined"
    @input="$emit('update:modelValue', $event.target.value)">
</template>

<script>
export default {
  name: 'text-input',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: [String, Number], default: '' },
    // The native input type: text, email, number, …
    native: { type: String, default: 'text' },
    align: { type: String, default: 'start' },
  },
  computed: {
    // A value too long for its capsule is cut off; the whole of it shows on hover.
    long() {
      return String(this.modelValue ?? '').length > 18
    },
  },
}
</script>
